import allowed from '@/core/constants/allowed-roles.constant'

const routes = [
  {
    name: 'risk-catalogue',
    path: '/risk-exposure',
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'risk-catalogue',
      breadcrumb: {
        label: 'core.menu.modules.risk-exposure',
        route: 'risk-catalogue',
      },
    },
    children: [
      {
        name: 'risk-catalogue-home',
        path: '/risk-exposure/risk-catalogue',
        meta: {
          allowedRoles: [...allowed.risk_catalogue.roles],
          embedFullViewport: false,
          breadcrumb: {
            label: 'core.menu.modules.risk-catalogue',
            route: 'risk-catalogue-home',
          },
        },
        component: () =>
          import(
            '@/modules/risk-catalogue/pages/risk-catalogue/risk-catalogue.vue'
          ),
      },
      {
        name: 'risk-catalogue-settings',
        path: '/risk-exposure/risk-catalogue/settings',
        meta: {
          allowedRoles: [...allowed.risk_catalogue.roles],
          breadcrumb: {
            label: 'core.menu.modules.risk-catalogue-settings',
            route: 'risk-catalogue-settings',
          },
        },
        component: () =>
          import(
            '@/modules/risk-catalogue/pages/settings/risk-catalogue-settings.vue'
          ),
      },
      {
        name: 'risk-catalogue-industry-type',
        path: '/risk-exposure/risk-catalogue/:industryTypeId',
        meta: {
          allowedRoles: [...allowed.risk_catalogue.roles],
          embedFullViewport: false,
          breadcrumb: {
            label: 'core.menu.modules.risk-catalogue',
            route: 'risk-catalogue-industry-type',
          },
        },
        component: () =>
          import(
            '@/modules/risk-catalogue/pages/risk-catalogue/risk-catalogue.vue'
          ),
      },
    ],
  },
]

export default routes
